import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApplicationLoaderService {
  // signals
  private _isLoadingState = signal<boolean>(false);
  // public readonly signal (getter)
  public readonly isLoading = this._isLoadingState.asReadonly();

  public showApplicationLoader() {
    this._isLoadingState.set(true);
  }

  public hideApplicationLoader() {
    this._isLoadingState.set(false);
  }
}
